import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4819882f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "survey-files d-flex flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "upload-list d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Layer name"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Files"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "hidden-buttons" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "py-5 text-center"
}
const _hoisted_11 = { class: "pt-3" }
const _hoisted_12 = {
  key: 1,
  class: "d-flex h-100 align-items-center justify-content-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Project has no surveys. Add a new one.", -1))
const _hoisted_14 = [
  _hoisted_13
]

import UploadFilesDialog from "@/components/Modals/UploadFilesDialog.vue";
import { useAppStateStore } from "@/store/app-state";
import { useDataStore } from "@/store/data-store";

import { computed, onMounted, ref } from "vue";
import { SurveyInputData, SurveyInputDataStatusEnum } from "@/swagger";
import { useRoute } from "vue-router";
import { LayerItemType } from "@/classes/data-structures/layer-item-type";


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyFiles',
  setup(__props) {

const appStore = useAppStateStore();
const dataStore = useDataStore();
const route = useRoute();

const uploadDialog = ref<typeof UploadFilesDialog>();

const surveyFiles = computed(()=>{
	if(appStore.view1Survey?.inputFiles != null){
		const files = appStore.view1Survey.inputFiles;
		return files.sort((a,b)=>b.uploadDate.getTime()-a.uploadDate.getTime());
	}else{
		return []
	}
})

function getStatusText(status: SurveyInputDataStatusEnum): string {
	switch (status) {
		case SurveyInputDataStatusEnum.Processed:
			return "Processed";
		case SurveyInputDataStatusEnum.Processing:
			return "Processing";
		case SurveyInputDataStatusEnum.Processingfailed:
			return "Processing failed";
		case SurveyInputDataStatusEnum.Uploading:
			return "Uploading";
		case SurveyInputDataStatusEnum.Waitingforprocessing:
			return "Waiting for processing";
		default:
			return `${status}`;
	}
}

async function refreshSurvey() {
	await appStore.reloadCurrentProject();
}

function showUploadFilesDialog() {
	uploadDialog.value.show();
}

async function reprocessSurveyUpload(file: SurveyInputData) {
	await dataStore.reprocessSurveyUpload(file.uuid);
	await appStore.reloadCurrentProject();
}

async function deleteSurveyUpload(file: SurveyInputData) {
	const shouldDelete = confirm(`Are you sure you want to delete "${file.name}" data.`);
	if (shouldDelete) {
		await dataStore.deleteSurveyUpload(file.uuid);
		await appStore.reloadCurrentProject();
	}
}

onMounted(() => {
	//Check if we need to open dialog for uploading imediately
	if (route.query.openUpload) {
		let uploadType: any = null;
		if (route.query.openUpload == LayerItemType.Orthophoto) {
			uploadType = "orthophoto";
		} else if (route.query.openUpload == LayerItemType.Meshes) {
			uploadType = "model";
		} else if (route.query.openUpload == LayerItemType.Cad) {
			uploadType = "cad";
		} else if (route.query.openUpload == LayerItemType.PointClouds) {
			uploadType = "pointcloud";
		} else if (route.query.openUpload == LayerItemType.Profiles) {
			uploadType = "profile";
		} else if (route.query.openUpload == LayerItemType.Volumes) {
			uploadType = "volume";
		}
		uploadDialog.value.show(uploadType);
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(appStore).view1Survey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", null, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(surveyFiles), (file) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: file.uuid
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["filetype", [file.type]]),
                        title: file.type
                      }, null, 10, _hoisted_5)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(file.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex align-items-center", [file.status]])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(['me-2', 'status-icon', file.status])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(getStatusText(file.status)), 1)
                      ], 2)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(file.originalFileUrls.length) + "/" + _toDisplayString(file.requiredFilesForProcessing), 1),
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "btn-reprocess btn-link",
                          onClick: ($event: any) => (reprocessSurveyUpload(file))
                        }, "Reprocess", 8, _hoisted_8),
                        _createElementVNode("button", {
                          class: "btn-delete btn-link",
                          onClick: ($event: any) => (deleteSurveyUpload(file))
                        }, "Delete", 8, _hoisted_9)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (!_unref(appStore).view1Survey.inputFiles || _unref(appStore).view1Survey.inputFiles.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " No files were uploaded "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showUploadFilesDialog()))
              }, "+ Add files")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(appStore).project?.surveys.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true),
    _createVNode(UploadFilesDialog, {
      surveyuuid: _unref(appStore).view1Survey?.uuid,
      ref_key: "uploadDialog",
      ref: uploadDialog,
      onOnHide: _cache[1] || (_cache[1] = ($event: any) => (refreshSurvey()))
    }, null, 8, ["surveyuuid"])
  ]))
}
}

})